(function() {
  function initButtonHandler() {
    var sections = document.querySelectorAll('.party-ship');

    sections.forEach(function(section) {
      var customBtn = section.querySelector('.party-ship__hero-content .custom-hero-btn');
      var appBtn = section.querySelector('.party-ship__ugc .cpu-uploader__open');

      if (customBtn && appBtn) {
        customBtn.addEventListener('click', function(e) {
          e.preventDefault();

          var savedScrollY = window.scrollY || window.pageYOffset;
          var observer = new MutationObserver(function() {
            var bodyStyle = window.getComputedStyle(document.body);
            var isLocked = bodyStyle.overflow === 'hidden' || bodyStyle.position === 'fixed';
            if (!isLocked) {
              observer.disconnect();
              window.scrollTo({ top: savedScrollY, behavior: 'instant' });
            }
          });
          observer.observe(document.body, { attributes: true, attributeFilter: ['style', 'class'] });

          appBtn.click();
        });
      }
    });
  }

  function makeImageClickable(img) {
    img.style.cursor = 'pointer';
    img.addEventListener('click', function() {
      window.location.href = '/collections/frontpage';
    });
  }

  function initImageHandler() {
    document.querySelectorAll('.party-ship__ugc .cpu-gallery__img').forEach(makeImageClickable);
  }

  function init() {
    initButtonHandler();
    initImageHandler();
  }

  var observer = new MutationObserver(function() {
    initImageHandler();
  });

  var container = document.querySelector('.party-ship__ugc');
  if (container) {
    observer.observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();